
class Config {

    // BASE_URL = "http://localhost:4000"
    BASE_URL = "https://click-learn.herokuapp.com"
    // BASE_URL = "http://13.53.192.109"
}

export const config = new Config();
